import React from 'react';
import { motion } from 'framer-motion';
export function Problem() {
  return <section className="bg-light py-24 px-4" data-id="element-213">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="max-w-3xl mx-auto space-y-12" data-id="element-214">
        <div className="text-center" data-id="element-215">
          <span className="text-primary font-bold uppercase tracking-wider text-sm mb-2 block" data-id="element-216">
            La Realidad
          </span>
          <h2 className="text-3xl md:text-5xl text-dark font-display font-extrabold tracking-headline leading-tight" data-id="element-217">
            ¿Te suena familiar?
          </h2>
        </div>

        <div className="space-y-8 text-lg md:text-xl text-body leading-relaxed bg-white rounded-[24px] border border-border shadow-lg p-8 md:p-12 relative overflow-hidden" data-id="element-218">
          <div className="absolute top-0 left-0 w-2 h-full bg-primary" data-id="element-219"></div>

          <p data-id="element-220">
            ¿Alguna vez has mirado tus estados de WhatsApp viendo a otras
            personas ganar dinero y te has preguntado:{' '}
            <span className="font-bold text-dark" data-id="element-221">
              "¿Por qué yo no puedo hacerlo?"
            </span>
          </p>

          <p data-id="element-222">
            Sé lo que se siente mirar la cuenta de banco a mitad de mes, sentir
            el peso de la inflación en USA y saber que el costo del daycare es
            tan alto que salir a trabajar a una oficina simplemente{' '}
            <span className="font-bold text-primary" data-id="element-223">
              no tiene sentido financiero
            </span>
            .
          </p>

          <div className="bg-primary/5 p-6 rounded-[16px] border border-primary/10" data-id="element-224">
            <p className="font-medium text-dark" data-id="element-225">
              Quieres ayudar en casa, quieres tus propios ingresos, pero el
              tiempo simplemente no te alcanza.
            </p>
          </div>
        </div>
      </motion.div>
    </section>;
}